<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}" id="toggle_cache">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="material-table-widget dashboard_top_bar">
              <div class="row">
                <div class="col-md-6">
                  <button class="btn btn-default btn-new v-step-0-2" id="show-modal" @click="DealModal = true;"><i class="fa fa-file-invoice-dollar"></i>&nbsp;新交易</button>
                  <h5 class="dashboard_top_bar_info" v-if="status_filter=='open'">{{deals_amount}}個交易，總金額：{{deals_total.toLocaleString()}}</h5>
                  <h5 class="dashboard_top_bar_info" v-else>{{filterClosedDeals.length}}個交易，總金額：NT$ {{getTotalAmount(filterClosedDeals).toLocaleString()}}</h5>
                </div>
                <div class="col-md-6 form-inline text-right display-block">
                  <button class="btn btn-default" @click="GoSetting"><i class="zmdi zmdi-settings"></i></button>
                  <!-- <button class="btn btn-default" @click="GoSetting"><i class="fas fa-filter"></i></button> -->
                  <select v-model="date_filter" class="form-control" v-if="status_filter!='open'" @change="setYearCookie()">
                  	<option v-for="year in year_ranges" :value="year">{{year}}</option>
                  </select>
                  <select v-model="status_filter" class="form-control">
                    <option value="open" selected="">進行中交易</option>
                    <option value="won">已簽約交易</option>
                    <option value="lost">已失去交易</option>
                  </select>
                  <select v-model="filter_deal_owner" class="form-control" @change="setFilterDealOwner()">
                    <option value="all">所有人</option>
                    <option v-for="user in company_users" v-bind:value="user.user_tag">{{user.user_name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="material-table-widget">
              <div class="main-deal-wrapper" id="deal-wrapper" v-bind:style="deal_box_scroll">
                <div class="row v-step-6-1" v-if="status_filter=='open'" v-bind:style="deal_box_width">
                  <ul class="col-md-12 draggable_title" id="deal-wrapper-head">
                    <li class="deal-init deal-stage v-step-0-3" v-for="stage in stages" v-bind:style="thead_style">
                      <h4>{{stage.name}}</h4>
                      <small>NT$ {{deals_stage_total[stage.stage_no].toLocaleString()}}   &nbsp;   {{deals_stage_amount[stage.stage_no]}} 筆交易</small>
                    </li>
                  </ul>
                  <ul class="col-md-12 draggable_title v-step-0-4" id="deal-wrapper-content">
                    <li class="deal-init deal-area" v-for="stage in stages" v-bind:style="tbody_style" :data-stage-no="stage.stage_no">
                      <draggable v-model="filterDealsWithStage[stage.stage_no]" :options="dragOptions" :move="getDraggedData">
                        <transition-group tag="ul" class="list-group deal-scroll-box">
                          <li class="list-group-item" v-for="deal in filterDealsWithStage[stage.stage_no]" v-if="deal.deal_stage == stage.stage_no" :key="deal.deal_stage" v-bind:id="deal.deal_token" @click="ShowDeal(deal.deal_token)">
                            <span>{{deal.deal_title}}</span>
                            <br>
                            <span>NT$ {{deal.deal_value.toLocaleString()}}</span>
                            <span>{{deal.deal_organization}}</span>
                          </li>
                        </transition-group>
                      </draggable>
                      <a @click="CreateStageDeal(stage.stage_no)" class="new-deal-button" style="display:block;text-align:center;"><i class="fa fa-plus"></i></a>
                    </li>
                  </ul>
                </div>
                <div class="row" v-else> 
                  <div class="col-md-12" v-if="filterClosedDeals.length==0">
                    <div class="widget-wrap">
                      <h5 v-if="status_filter == 'won'">無任何成功的交易</h5>
                      <h5 v-if="status_filter == 'lost'">無任何失去的交易</h5>
                    </div>
                  </div>
                  <div class="col-md-12" v-for="(month_deals, index) in MonthyClosedDeals" v-if="month_deals.length != 0">
                    <div class="widget-wrap">
                      <h4 class="text-left">{{index+1}}月 <small class="pull-right">{{month_deals.length}}個交易 , 總金額：NT {{getTotalAmount(month_deals).toLocaleString()}}</small></h4>
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-center col-xs-3">交易名稱</th>
                            <th class="text-center col-xs-2">金額</th>
                            <th class="text-center col-xs-2">公司</th>
                            <th class="text-center col-xs-2">完成日期</th>
                            <th class="text-center" v-if="filter_deal_owner=='all'">所屬業務</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="pointer" v-for="deal in month_deals" @click="ShowDeal(deal.deal_token)">
                            <td>{{deal.deal_title}}</td>
                            <td>NT$ {{deal.deal_value.toLocaleString()}}</td>
                            <td>{{deal.deal_organization}}</td>
                            <td>{{deal.deal_time}}</td>
                            <td v-if="filter_deal_owner=='all'">
                              <div v-html="getOwnerInfo(deal.deal_owner)"></div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <!-- start sales target -->
      <div class="sales_target_box" v-model="filterTargets">
        <div class="date-box pointer" @click="GoUser">
          <div class="date-month">{{ new Date() | moment("MM") }}月</div>
          <div class="sales-number" v-if="this.sales_target == 0">
            <span>無目標</span>
            <button class="btn btn-info btn-xs"><i class="fa fa-pencil-alt"></i></button>
          </div>
          <div class="sales-number has_number" style="line-height:20px;text-align:center" v-if="this.sales_target != 0">
            <span>{{sales_deal_amount.toLocaleString()}}<hr>{{sales_target.toLocaleString()}}</span>
          </div>
        </div>
        <div class="progress-box">
          <div class="progress sales pointer" v-tooltip="sales_bar_wording">
            <div v-bind:class="'progress-bar '+ sales_bar_color " role="progressbar" aria-valuenow="50"
            aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: sales_percent + '%'}">
              {{sales_percent}}% 
            </div>
          </div>
          <div class="progress month pointer" v-tooltip="this.date_alert">
            <div class="progress-bar progress-bar-info" role="progressbar"  v-bind:style="{width: date_percent + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
      <!-- end sales target -->
    </section>
    <!-- modal template start-->
    <div v-if="DealModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="close_modal">
          <div class="modal-container col-md-8" @click.stop>
            <div class="modal-header text-center" style="display:block;">
              <div name="header">
                <h4>新增交易</h4>
              </div>
              <a href="#" class="btn-close" @click="close_modal">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body" style="overflow:initial">
              <div class="row j-forms">
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-file-invoice-dollar"></i></label>
                      <input class="form-control" type="text" placeholder="交易名稱*" name="deal_title" v-model="deal_title" v-validate="'required'">
                      <i v-show="errors.has('deal_title')" class="fa fa-warning"></i>
                      <span v-show="errors.has('deal_title')" class="help is-danger">不可為空值
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-dollar-sign"></i></label>
                      <input class="form-control login-frm-input" type="text" placeholder="價格*" name="deal_value" v-model="deal_value" v-validate="'required|numeric'">
                      <i v-show="errors.has('deal_value')" class="fa fa-warning"></i>
                      <span v-show="errors.has('deal_value')" class="help is-danger">請輸入金額，或你預估的可能金額
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-filter" aria-hidden="true"></i></label>
                      <select name="deal_stage" v-model="deal_stage" class="form-control login-frm-input" v-validate="'required'">
                        <option disabled value="">請選擇交易階段*</option>
                        <option v-for="stage in stages" v-bind:value="stage.stage_no">
                          {{stage.name}}
                        </option>
                      </select>
                      <i v-show="errors.has('deal_stage')" class="fa fa-warning"></i>
                      <span v-show="errors.has('deal_stage')" class="help is-danger">請選擇交易階段
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-calendar" aria-hidden="true"></i></label>
                      <datepicker input-class="form-control login-frm-input" placeholder="預期訂單完成時間" v-model="deal_expected_close_date" language="zh" :format="customFormatter"></datepicker>
                    </div>
                  </div>                    
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-user"></i></label>
                      <autocomplete :url="axios.defaults.baseURL + '/settings/auto_complete'" anchor="name" label="organization_name" param="keyword" name="autocomplete1" placeholder="聯絡人*" v-model="deal_contact_name" :classes="{ input: 'form-control  deal_contact_name', wrapper: 'input-wrapper'}" :process="process_contact_JSON" :onSelect="handle_contact_Select" :onInput="set_contact_Value" :customHeaders=auth_token :customParams="{ type: 'contact' }">
                      </autocomplete>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-building"></i></label>
                      <autocomplete :url="axios.defaults.baseURL + '/settings/auto_complete'" anchor="name" label="contact_name" param="keyword" name="autocomplete2" placeholder="公司名稱" v-model="deal_organization_name" v-show="!contact_been_selected" :classes="{ input: 'form-control login-frm-input deal_organization_name', wrapper: 'input-wrapper'}" :process="process_organization_JSON" :onSelect="handle_organization_Select" :onInput="set_organization_Value" :customHeaders=auth_token :customParams="{ type: 'organization' }">
                      </autocomplete>
                      <input class="form-control" type="text" name="deal_organization_name" v-model="deal_organization_name" disabled="" v-show="contact_been_selected">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-phone"></i></label>
                      <input class="form-control login-frm-input" id="deal_contact_phone" type="text" placeholder="聯絡人電話" name="deal_contact_phone" v-model="deal_contact_phone">
                      <i v-show="errors.has('deal_contact_phone')" class="fa fa-warning"></i>
                      <span v-show="errors.has('deal_contact_phone')" class="help is-danger">請輸入聯絡人電話</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-envelope"></i></label>
                      <input class="form-control login-frm-input" id="deal_contact_email" type="text" placeholder="聯絡人Email" name="deal_contact_email" v-model="deal_contact_email">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms col-md-12">
              <div name="footer">
                <button v-if="submit_loading==false" class="btn btn-primary" @click="validateBeforeSubmit">
                  建立
                </button>
                <button v-else class="btn btn-primary" disabled>
                  建立中...
                </button>
                <button class="btn btn-primary" @click="close_modal">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import autocomplete from 'vue2-autocomplete-js'
import { getCookie, setCookie } from '../assets/js/elffy_js/cookie.js'

export default {
  name: 'Main',
  components: {
    draggable,
    Datepicker,
    autocomplete,
  },
  data() {
    return {
      deals: [],
      closed_deals: [],
      stages: [],
      deals_stage_total: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      deals_stage_amount: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      thead_style: '',
      tbody_style: '',
      DealModal: false,
      submit_loading: false,
      deal_title: '',
      deal_value: '',
      deal_stage: '',
      deal_expected_close_date: '',
      deal_organization_name: '',
      deal_contact_name: '',
      deal_contact_phone: '',
      deal_contact_email: '',
      content_cache: '',
      dragged_data: '',
      deals_total: 0,
      deals_amount: 0,
      auth_token: {},
      contact_been_selected: false,
      status_filter: 'open',
      filter_deal_owner: 'all',
      user_permission: '',
      filter_deals: [],
      company_users: [],
      date_percent: 0,
      sales_targets:[],
      sales_percent: 0,
      sales_deal_amount: 0,
      sales_target: 0,
      sales_bar_color: '',
      sales_bar_wording: '',
      date_alert: "",
      date_filter: new Date().getFullYear(),
      deal_box_scroll: "",
      deal_box_width: "",
     	year_ranges: [new Date().getFullYear()],
    }
  },
  beforeCreate: function() {
    document.body.className = 'dashboard';
  },
  created() {
    this.getUserInfo();
    this.getUserSalesTarget();
    this.getYearCookie();
  },
  // watch: {
  //     deals: function () {
  //         this.syncDealArray();
  //     }
  // },
  props: ['toggle_aside'],
  computed: {
    dragOptions() {
      var stage_len = this.stages.length
      const vm = this;
      vm.deals_total = 0
      vm.deals_amount = 0
      // update all deal stage on dashboard
      for (var i = 0; i <= stage_len - 1; ++i) {
        var sum_of_value = 0
        var amount_of_deal = 0
        vm.filter_deals[i].forEach(function(deal) {
          deal.deal_stage = i
          sum_of_value += deal.deal_value
          amount_of_deal += 1
          if (vm.dragged_data.deal_token == deal.deal_token && vm.dragged_data.deal_stage != deal.stage) {
            vm.updateStage(deal)
          }
        });
        // count the amount of deals and total value 
        vm.deals_stage_total[i] = sum_of_value
        vm.deals_stage_amount[i] = amount_of_deal
        vm.deals_total += vm.deals_stage_total[i]
        vm.deals_amount += vm.deals_stage_amount[i]

      }
      return {
        group: 'description',
        ghostClass: 'ghost'
      };
    },
    filterClosedDeals: function () {
      let vm = this
      //return this.products
      // return _.orderBy(this.closed_deals, 'deal_time')
      let return_deals = this.closed_deals.sort( ( a, b) => {
        return new Date(a.deal_time) - new Date(b.deal_time);
      });
      return_deals = return_deals.filter(deal => 
        moment(deal.deal_time, 'YYYY-MM-DD').year() == vm.date_filter
      );
      return_deals = return_deals.filter(deal => 
        deal.deal_status == vm.status_filter
      );
      if(this.filter_deal_owner!= 'all'){
        return_deals = return_deals.filter(deal => 
          deal.deal_owner == vm.filter_deal_owner
        );
      }
      //return return_deals
      return return_deals
    },
    MonthyClosedDeals: function () {
      let vm = this
      //return this.products
      // return _.orderBy(this.closed_deals, 'deal_time')
      var monthly_deals = [[],[],[],[],[],[],[],[],[],[],[],[]]
      for (var i = 0; i < monthly_deals.length; i++) {
        let month = i
        monthly_deals[i]= vm.filterClosedDeals.filter(deal => 
          moment(deal.deal_time, 'YYYY-MM-DD').month() == month
        );
      }
      //return return_deals
      return monthly_deals
    },
    filterTargets: function() { 
      //從選擇的對象，過濾sales_target
      var filter_targets = this.sales_targets
      var vm = this
      var sales_deal_amount = 0
      var sales_target = 0
      var date = moment(new Date()).format('DD')
      var days_in_month = moment(new Date()).daysInMonth()
      if (this.filter_deal_owner != 'all') {
        filter_targets = filter_targets.filter(sales_target => sales_target.user_id == vm.filter_deal_owner)
      }
      //過濾結束，開始計算
      filter_targets.forEach(function(st) {
        sales_deal_amount += st.deal_amount
        sales_target += st.target
      })

      //把結果套入
      vm.sales_deal_amount = sales_deal_amount
      vm.sales_target = sales_target
      vm.date_percent= Math.round(date*1000/days_in_month)/10
      vm.sales_percent=Math.round(vm.sales_deal_amount*1000/vm.sales_target)/10
      vm.date_alert = ("5月已經過了" + date+ "天囉("+vm.date_percent+"%)")
      if(vm.sales_target == 0 || vm.sales_target == ""){
        //沒設定目標
        vm.sales_percent = 0
        vm.sales_bar_wording = "你目前沒有目標，請快去設定，或請你的主管幫你設定吧！業務人生怎麼可以沒目標！？"
        vm.sales_bar_color = 'progress-bar-default'
      }else if(vm.sales_percent <  (vm.date_percent*2/3) && vm.sales_percent > 0){
        //目標低於理想目標2/3以下
        vm.sales_bar_wording = "你的目標已達成"+vm.sales_deal_amount.toLocaleString()+"("+ vm.sales_percent + "%)囉。距離合理目標"+ (vm.date_percent*vm.sales_target/100).toLocaleString() +"("+ vm.date_percent + "%)還有段距離"+ (vm.date_percent*vm.sales_target/100-vm.sales_deal_amount).toLocaleString() +"，加油趕上！"
        vm.sales_bar_color = 'progress-bar-danger'
      }else if((vm.sales_percent >= (vm.date_percent*2/3)) && (vm.sales_percent < vm.date_percent)){
        //目標在2/3以上，小於期望值
        vm.sales_bar_wording = "你的目標已達成"+vm.sales_deal_amount.toLocaleString()+"("+ vm.sales_percent + "%)囉。你快追上目標了"+"("+ vm.date_percent + "%)！"
        vm.sales_bar_color = 'progress-bar-warning'
      }else if(vm.sales_percent >= vm.date_percent){
        //目標在期望值以上
        vm.sales_bar_wording = "你的目標已達成"+vm.sales_deal_amount.toLocaleString()+"("+ vm.sales_percent + "%)囉。繼續保持！你就可以順利達成本月目標喔！"
        vm.sales_bar_color = 'progress-bar-info'
      }
      vm.sales_bar_color
      return filter_targets
    },
    filterDealsWithStage: function() {    
      setCookie('filter_deal_owner', this.filter_deal_owner, 7)
      setCookie('status_filter', this.status_filter, 7)
      if (['all', 'won', 'open', 'lost'].indexOf(this.status_filter) > -1) {
        // all deals
        if (this.status_filter == 'all') {
          this.filter_deals = this.deals
        } else {
          // filter by deal status
          var return_deals = [
            [],
            [],
            [],
            []
          ]
          for (var i = 0; i < this.stages.length; i++) {
            if (this.deals[i].length > 0) {
              var filter_deal = this.deals[i].filter(deal => deal.deal_status == this.status_filter)
              if (filter_deal != undefined) {
                return_deals[i] = filter_deal
              } else {
                return_deals[i] = []
              }
            } else {
              return_deals[i] = []
            }
          }
          this.filter_deals = return_deals
        }
      }
      if (this.filter_deal_owner != 'all') {
        // filter by company user
        var return_deals = [
          [],
          [],
          [],
          []
        ]
        for (var i = 0; i < this.stages.length; i++) {
          if (this.filter_deals[i].length > 0) {
            var filter_deal = this.filter_deals[i].filter(deal => deal.deal_owner == this.filter_deal_owner)
            if (filter_deal != undefined) {
              return_deals[i] = filter_deal
            } else {
              return_deals[i] = []
            }
          } else {
            return_deals[i] = []
          }
        }
        this.filter_deals = return_deals
      }
      return return_deals
    },
  },
  methods: {
    setFilterDealOwner(){
      setCookie('filter_deal_owner', this.filter_deal_owner, 7)
    },
    getUserSalesTarget() {
      //拿所有的公司用戶的SalesTarget
      var vm = this;
      this.axios.get('sales_targets').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.sales_targets = response['data']['data']['sales_targets']
          } else if (response.status == 200 && response['data']['status'] == 'fail') {
            console.log('Error')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    getUserInfo() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      const vm = this;
      // user access token
      vm.auth_token = { 'Auth-Token': getCookie('auth_token') }
      this.axios.get('dashboards').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            // deal stages
            vm.stages = response['data']['data']['stages']
            vm.year_ranges = response['data']['data']['year_ranges']
            var stage_len = vm.stages.length
            // auto calculate draggable view width
            var width = document.getElementById('deal-wrapper-head').offsetWidth - 18
            var stage_colmn_num = stage_len
            if(stage_len<4){
              stage_colmn_num = 4
            }

            vm.thead_style = {
              'width': 'calc(' + 100 / stage_colmn_num + '% - 12px'
            }
            vm.tbody_style = {
              'width': 'calc(' + 100 / stage_colmn_num + '% - 12px'
            }
            if(stage_len > 4){
              vm.deal_box_scroll = 'overflow:scroll'
              vm.deal_box_width = 'width:'+97/4*stage_len+'%'
            }else{
              vm.deal_box_scroll = ""
              vm.deal_box_width = ""
            }
            // get company deals if existed
            if (response['data']['data']['deals']) {
              for (var i = 0; i <= stage_len - 1; ++i) {
                vm.deals[i] = response['data']['data']['deals'][i]
              }
            }
            // if no deals then assign empty array
            else {
              for (var i = 0; i <= stage_len - 1; ++i) {
                vm.deals[i] = []
              }
            }
            // user_permission
            vm.user_permission = response['data']['data']['user_permission']
            // company_users
            vm.company_users = response['data']['data']['company_users']
            // initial deal_owner_user
            vm.filter_deal_owner = response['data']['data']['deal_owner_user']
            // assign filter_deals for deals filter
            vm.filter_deals = vm.deals
            // 暫時用來作為已失敗交易、已完成交易的deal顯示，需要優化
            vm.closed_deals = response['data']['data']['closed_deals']

            // get filter cookie if existed
            if(getCookie('status_filter')!= ''){
              vm.status_filter = getCookie('status_filter')
            }
            if(getCookie('filter_deal_owner')!= ''){
              vm.filter_deal_owner = getCookie('filter_deal_owner')
            }
          } else if (response.status == 200 && response['data']['status'] == 'fail') {
            console.log('Error')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    createDeal() {
      // define vm to assign this (assign vue data) because in axios there is other this
      const vm = this;
      this.submit_loading = true
      this.axios.post('deals', {
          deal: {
            title: this.deal_title,
            value: this.deal_value,
            stage: this.deal_stage,
            expected_close_date: this.deal_expected_close_date,
            organization_name: this.deal_organization_name,
            contact_name: this.deal_contact_name,
            contact_phone: this.deal_contact_phone,
            contact_email: this.deal_contact_email
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.deals[vm.deal_stage].push(response['data']['data']['deal'])
            vm.filter_deals = vm.deals
            vm.DealModal = false
          } else {
            console.log(response)
          }
          vm.submit_loading = false
        })
        .catch(function(error) {
          console.log('error:', error)
          this.submit_loading = false
        });
    },
    ShowDeal(deal_token) {
      this.$router.push({ name: 'deal', params: { deal_token: deal_token } })
    },
    getDraggedData: function(event) {
      this.dragged_data = event.draggedContext.element
    },
    CreateStageDeal(stage_no) {
      this.deal_stage = stage_no
      this.DealModal = true
    },
    updateStage(deal) {
      this.axios.put('deals/update_stage', {
          deal: {
            stage: deal.deal_stage,
            deal_token: deal.deal_token
          }
        })
        .then(function(response) {
          if (response.status == 200) {
          } else {
            console.log('Update Stage Fail')
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    // AutoComplete callback function (Organization)
    process_organization_JSON(json) {
      return json.results.organization;
    },
    // if organization selected, auto assign deal name 
    handle_organization_Select(data) {
      this.deal_organization_name = data.name
      if(!this.deal_title){
        this.deal_title = data.name + "的交易"
      }
    },
    // keyup organization name
    set_organization_Value(value) {
      this.deal_organization_name = value
    },

    // AutoComplete callback function (Contact)
    process_contact_JSON(json) {
      return json.results.contact;
    },
    handle_contact_Select(data) {
      // if contact selected, disable input contact infos
      $('#deal_contact_phone').prop("disabled", true);
      $('#deal_contact_email').prop("disabled", true);
      this.contact_been_selected = true
      this.deal_contact_name = data.name
      this.deal_organization_name = data.organization_name
      if(!this.deal_title){
        this.deal_title = data.name + "的交易"
      }
    },
    set_contact_Value(value) {
      // if keyup contact name instead select, then should also input contact infos
      this.contact_been_selected = false
      $('#deal_contact_phone').prop("disabled", false);
      $('#deal_contact_email').prop("disabled", false);
      this.deal_contact_name = value
    },
    // if modal closed, then should clear input values
    close_modal() {
      this.DealModal = false
      this.contact_been_selected = false
      this.deal_organization_name = ""
      this.deal_contact_name = ""
      this.deal_title = ""
      this.deal_value = ""
    },
    // validation input
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createDeal();
        } else {
          console.log('fails')
        }
      });
    },
    GoSetting() {
      this.$router.push('/setting/set_stages')
    },
    customFormatter(date) {
      moment.locale('zh-tw');
      return moment(date).format('YYYY MMM Do');
    },
    GoUser() {
      this.$router.push('/user_profile')
    },
    getTotalAmount(deals){
      var amount = 0
      deals.forEach(function(d) {
        amount += d.deal_value
      })
      return amount
    },
    getOwnerInfo(owner_id){
      if(owner_id){
        var return_user = this.company_users.filter(user =>
          user.user_tag == owner_id
        )
        console.log(return_user)
        var img = ""
        var name = ""
        var return_html = ""
        if(return_user.length != 0){
          var user = return_user[0]
          if(user.user_profile_pic){
            img = user.user_profile_pic
          }else{
            img = "../assets/img/logo1.png"
          }
          return_html = '<img class="avatar-size" src="'+ img +'">' + '<span>'+ user.user_name +'</span>'
          return return_html
        }else{
          return '未知業務'
        }
      }else{
        return '無業務'
      }
    },
    setYearCookie(){
    	setCookie("now_year",this.date_filter,'year selected store');
    },
    getYearCookie(){
    	if(getCookie("now_year")!=null || getCookie("now_year")!=''){
    		this.date_filter = getCookie("now_year");
    		console.log(getCookie("now_year"),'getCookie("now_year")')
    	}
    },
  },
}
</script>


// WEBPACK FOOTER //
// Dashboard.vue?d5b23988